import { useDrag } from 'react-dnd'

import {Card} from "@mui/material";

const style = {
    float: 'left',
    width:"100%"
}





export const Box = function Box({ name,id,content,onDrop,onClick,draggable = true }) {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'box',
        item: { name,id },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult()
            if (item && dropResult) {
                onDrop(item.id,dropResult.name);
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            handlerId: monitor.getHandlerId(),
        }),
    }),[id]);

    const opacity = isDragging ? 0.4 : 1
    return (
        <Card onClick={onClick} ref={draggable ? drag : null} style={{ ...style, opacity,cursor : draggable ? 'move' : 'pointer' }} data-testid={id}>{content}</Card>
    )
}
